import NavigationNH from "@/components/site/nh/NavigationNH";
import HeroNH from "@/components/site/nh/HeroNH";
import { DeploymentProvider, northHoustonDeployment } from "@/lib/DeploymentContext";
import ReadTimeStrip from "@/components/site/ReadTimeStrip";
import LineageNote from "@/components/site/LineageNote";
import EquityCommitment from "@/components/site/EquityCommitment";
import ThreeAsksNH from "@/components/site/nh/ThreeAsksNH";
import StrategicAlignmentNH from "@/components/site/nh/StrategicAlignmentNH";
import LocalContextNH from "@/components/site/nh/LocalContextNH";
import TwoProngedStrategy from "@/components/site/TwoProngedStrategy";
import TradePipelineNH from "@/components/site/nh/TradePipelineNH";
import MultigenerationalStoryNH from "@/components/site/nh/MultigenerationalStoryNH";
import SeniorCarePipeline from "@/components/site/SeniorCarePipeline";
import IntakeFramework from "@/components/site/IntakeFramework";
import ReferralNetworkNH from "@/components/site/nh/ReferralNetworkNH";
import GapAnalysis from "@/components/site/GapAnalysis";
import CDBGAlignmentNH from "@/components/site/nh/CDBGAlignmentNH";
import BudgetGateNH from "@/components/site/nh/BudgetGateNH";
import FederalStrategy from "@/components/site/FederalStrategy";
import ImageGallery from "@/components/site/ImageGallery";
import MunicipalPartnershipNH from "@/components/site/nh/MunicipalPartnershipNH";
import ContactForm from "@/components/site/ContactForm";
import StickyCTA from "@/components/site/StickyCTA";
import Footer from "@/components/site/Footer";
import NDAGate from "@/components/site/NDAGate";

export default function NorthHoustonPage() {
  return (
    <NDAGate proposal="north-houston">
    <DeploymentProvider value={northHoustonDeployment}>
      <main data-testid="north-houston-page" className="bg-[#F9F7F1] text-[#0A192F]">
        <NavigationNH />
        <HeroNH />
        <ReadTimeStrip />
        <LineageNote />
        {/* ----- Opening: Equity · Three Asks ----- */}
        <EquityCommitment />
        <ThreeAsksNH />
        <StrategicAlignmentNH />
        {/* ----- The Need: District context + program mechanics ----- */}
        <LocalContextNH />
        <TwoProngedStrategy />
        <TradePipelineNH />
        <MultigenerationalStoryNH />
        <SeniorCarePipeline />
        <IntakeFramework />
        <ReferralNetworkNH />
        <GapAnalysis />
        <CDBGAlignmentNH />
        {/* ----- The Money + The Plan + The Federal Win ----- */}
        <BudgetGateNH />
        <FederalStrategy />
        {/* ----- Close: gallery, ask, contact ----- */}
        <ImageGallery />
        <MunicipalPartnershipNH />
        <ContactForm />
        <StickyCTA />
        <Footer />
      </main>
    </DeploymentProvider>
    </NDAGate>
  );
}
